var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.67057C14 10.3778 13.719 11.0561 13.2189 11.5562C12.7188 12.0563 12.0405 12.3372 11.3333 12.3372C10.626 12.3372 9.94777 12.0563 9.44767 11.5562C8.94758 11.0561 8.66663 10.3778 8.66663 9.67057C8.66663 8.96333 8.94758 8.28505 9.44767 7.78495C9.94777 7.28486 10.626 7.00391 11.3333 7.00391C12.0405 7.00391 12.7188 7.28486 13.2189 7.78495C13.719 8.28505 14 8.96333 14 9.67057Z",
    stroke: "#6B6B6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 9.67057C17.9999 16.019 11.3332 19.6706 11.3332 19.6706C11.3332 19.6706 4.66656 16.019 4.66656 9.67057C4.66656 7.90246 5.36894 6.20677 6.61919 4.95653C7.86943 3.70629 9.56512 3.00391 11.3332 3.00391C13.1013 3.00391 14.797 3.70629 16.0473 4.95653C17.2975 6.20677 17.9999 7.90246 17.9999 9.67057Z",
    stroke: "#6B6B6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarker);
export default __webpack_public_path__ + "static/media/location-marker.35ab0c8b11c0fdc39ca6a6f815947639.svg";
export { ForwardRef as ReactComponent };